/*eslint no-undef: "off"*/

import { useMutation } from '@tanstack/vue-query'

// Marks one recipient row (`id`) read, or every unread row scoped to `resourceId` (all when omitted).
export function useQueryNotificationUserMarkRead() {
    const { featureFlags } = useAnalytics()

    async function markRead({ id = null, resourceId = null } = {}) {
        const { dashboardAPI } = useAPI()

        if (id) return dashboardAPI(`/notifications/user/${id}/read`, { method: 'PATCH' })

        return dashboardAPI('/notifications/user/read', {
            method: 'PATCH',
            body: resourceId ? { resource_id: resourceId } : {},
        })
    }

    return useMutation({
        // No-ops while the notifications flag is off so nothing reaches the API.
        mutationFn: (scope) => (featureFlags.signalWatchNotifications ? markRead(scope) : null),
    })
}
